import React from "react";
import {calculateTakenPiecesFromFen, materialBalance} from "../utils/chessFunctions";
import {ChessPieces} from "../utils/chessPieces";

const ORDER = [ChessPieces.PAWN, ChessPieces.KNIGHT, ChessPieces.BISHOP, ChessPieces.ROOK, ChessPieces.QUEEN];

// Shows the pieces `color` has captured from the opponent, plus the material lead if there is one.
const CapturedPieces = ({fen, color}) => {
    if (!fen) return <div className="captured"/>;
    const opponent = color === "w" ? "black" : "white";
    const taken = calculateTakenPiecesFromFen(fen, opponent);
    const balance = materialBalance(fen) * (color === "w" ? 1 : -1);

    return (
        <div className="captured" aria-label="Captured pieces">
            {ORDER.map((piece) => {
                const amount = Math.max(0, taken.get(piece) || 0);
                if (amount === 0) return null;
                return (
                    <span className="captured__group" key={piece.fen}>
                        {Array.from({length: amount}).map((_, i) => (
                            <img key={i} src={piece.getImageSrc(opponent)} alt=""/>
                        ))}
                    </span>
                );
            })}
            {balance > 0 && <span className="captured__diff">+{balance}</span>}
        </div>
    );
};

export default CapturedPieces;
